import React from 'react';
import { useFormContext } from '../../context/FormContext';
import { Card } from '../ui/Card';
import { Input } from '../ui/Input';

export const ContactDetails = () => {
  const { data, updateData } = useFormContext();

  const handleChange = (e) => {
    updateData('contact', e.target.name, e.target.value);
  };

  const isInvalid = (val) => data.submitAttempted && !val;

  return (
    <Card className={`mb-8 transition-all ${data.submitAttempted && (!data.contact.firstName || !data.contact.lastName || !data.contact.email) ? 'ring-1 ring-red-400' : ''}`}>
      <div className="mb-6">
        <h3 className="text-[10px] font-bold text-brand-muted uppercase tracking-widest mb-2">Step 1</h3>
        <h2 className="text-xl font-serif text-brand-text">Add your contact details</h2>
        <p className="text-sm text-brand-muted mt-1">Use the details for the person responsible for this submission.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input 
          label="First Name" 
          name="firstName"
          value={data.contact.firstName}
          onChange={handleChange}
          placeholder="Jane"
          highlight={isInvalid(data.contact.firstName)}
          helpText="Your legal first name as it appears on official records."
        />
        <Input 
          label="Last Name" 
          name="lastName"
          value={data.contact.lastName}
          onChange={handleChange}
          placeholder="Doe"
          highlight={isInvalid(data.contact.lastName)}
          helpText="Your legal last name or surname."
        />
        <Input 
          label="Email" 
          name="email"
          type="email"
          className="md:col-span-2"
          value={data.contact.email}
          onChange={handleChange}
          placeholder="jane.doe@example.com"
          highlight={isInvalid(data.contact.email)}
          helpText="We will use this email to send a confirmation receipt."
        />
      </div>
    </Card>
  );
};